export default "__VITE_ASSET__Ch0CZHch__"